import type { ProjectId, AssetId } from 'owa-timestream-types';
import { getAssets, getAsset } from 'owa-timestream-store';
import type { NearbyAssets } from '../schema';

export default function findNearbyPointsForAsset(
    projectId: ProjectId,
    assetId: AssetId
): NearbyAssets {
    const assets = getAssets(projectId);
    const assetBounds = getAsset(projectId, assetId).bounds;
    let minUpDistance, minDownDistance, minLeftDistance, minRightDistance;
    minUpDistance = minDownDistance = minLeftDistance = minRightDistance = Number.MAX_VALUE;
    let upAsset, downAsset, leftAsset, rightAsset;
    upAsset = downAsset = leftAsset = rightAsset = null as AssetId | null;

    for (let i = 0; i < assets.length; i++) {
        const [relativeId, relativeAsset] = assets[i];
        const relativeX = relativeAsset.bounds.x;
        const relativeY = relativeAsset.bounds.y;
        if (relativeId === assetId || relativeAsset.parentId) {
            continue;
        }

        const xDist = Math.abs(assetBounds.x - relativeX);
        const yDist = Math.abs(assetBounds.y - relativeY);
        const totalDist = Math.sqrt(Math.pow(xDist, 2) + Math.pow(yDist, 2));

        if (xDist <= yDist) {
            // up, down take priority
            if (relativeY <= assetBounds.y) {
                // asset is above
                if (totalDist < minUpDistance) {
                    minUpDistance = totalDist;
                    upAsset = relativeId;
                }
            } else {
                // asset is below
                if (totalDist < minDownDistance) {
                    minDownDistance = totalDist;
                    downAsset = relativeId;
                }
            }
        }

        if (xDist >= yDist) {
            // left, right take priority
            if (relativeX <= assetBounds.x) {
                // asset is left
                if (totalDist < minLeftDistance) {
                    minLeftDistance = totalDist;
                    leftAsset = relativeId;
                }
            } else {
                // asset is right
                if (totalDist < minRightDistance) {
                    minRightDistance = totalDist;
                    rightAsset = relativeId;
                }
            }
        }
    }

    const updatedPOI: NearbyAssets = {
        up: upAsset,
        down: downAsset,
        left: leftAsset,
        right: rightAsset,
    };
    return updatedPOI;
}
